import React from "react"
import { TextoImpressaoContextProvider } from "./context/TextoImpressaoContextProvider"
import { TextosImpressao } from "./TextosImpressao"

export function IndexImpressao() {
    return (
        <TextoImpressaoContextProvider>
            <TextosImpressao />
        </TextoImpressaoContextProvider>
    )
}
